
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Create a simple function to measure time spent initializing the app
const measureStartupTime = () => {
  const start = performance.now();
  
  // Create and render root
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    console.error("Root element not found");
    return;
  }
  
  const root = createRoot(rootElement);
  
  // Add viewport meta tag for mobile responsiveness
  const setViewportMeta = () => {
    let viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) {
      viewport = document.createElement('meta');
      viewport.setAttribute('name', 'viewport');
      document.head.appendChild(viewport);
    }
    // Optimize for mobile to prevent 300ms tap delay and other mobile optimizations
    viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=5.0, minimum-scale=1.0, viewport-fit=cover');
  };
  
  // Add mobile optimization tags
  const addMobileOptimizations = () => {
    // Add touch-action manipulation to improve touch response
    const style = document.createElement('style');
    style.textContent = `
      * {
        -webkit-tap-highlight-color: transparent;
      }
      body, html {
        touch-action: manipulation;
        overscroll-behavior: none;
        -webkit-overflow-scrolling: touch;
      }
      img, svg {
        transform: translateZ(0); /* Force GPU rendering */
      }
    `;
    document.head.appendChild(style);
  };
  
  setViewportMeta();
  addMobileOptimizations();
  
  // Render the app directly without requestIdleCallback for better reliability
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
    
  // Record initialization time
  const end = performance.now();
  console.log(`App initialization took ${(end - start).toFixed(2)}ms`);

  // Report core web vitals after the page loads
  window.addEventListener('load', () => {
    // Use requestIdleCallback to not block the main thread
    requestIdleCallback(() => {
      if ('performance' in window) {
        const paintMetrics = performance.getEntriesByType('paint');
        const navigationTiming = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
        
        if (navigationTiming) {
          console.log(`Time to interactive: ${navigationTiming.domInteractive}ms`);
          console.log(`DOM content loaded: ${navigationTiming.domContentLoadedEventEnd}ms`);
          console.log(`Load complete: ${navigationTiming.loadEventEnd}ms`);
        }
        
        paintMetrics.forEach(metric => {
          console.log(`${metric.name}: ${metric.startTime}ms`);
        });
      }
    }, { timeout: 2000 });
  });
};

// Start the app with performance measurement
measureStartupTime();
